module.exports = __webpack_public_path__ + "static/img/John-Paul-Donevski.be6e3cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/John-Paul-Donevski.jpg
// module id = YR2I
// module chunks = 0